import React, { useEffect } from 'react'

import { BackToProjects } from '../../../../components/'
import Images from '../../../../constants/Images'

import './Project2.css'

const Project2 = () => {
  useEffect(() => {
    document.title = "Randy | Project 2";  
  }, []);

  return (
    <div className='project2_content'>
        <img src={Images.ProjectHSoon} alt="Project image header" />
        <div className='project2_content-summary'>
          <h2>Project 2</h2>
          <p>Jan 2020 - Mar 2020</p>
        </div>
        <BackToProjects />
    </div>
  )
}

export default Project2